import CorporateNavbar from '@/components/CorporateNavbar';
import CorporateFooter from '@/components/CorporateFooter';
import EtherealBackground from '@/components/EtherealBackground';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { useTranslations } from '../hooks/useTranslations';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const MusicProduction = () => {
  const t = useTranslations();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="min-h-screen flex flex-col relative"
      style={{ backgroundColor: '#FDFDFD' }}
    >
      <Helmet>
        <title>AIMusicDreams — AI-genererad musik | Aifinity</title>
        <meta name="description" content="AI-genererad musik av Aifinity AB. Lyssna på Spotify och SoundCloud." />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href="https://aifinity.se/artists" />
      </Helmet>
      <EtherealBackground />
      <div className="relative z-10">
        <CorporateNavbar />
        
        {/* Hero Section */}
        <section className="pt-32 pb-20 relative">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="sr-only">AIMusicDreams — AI-genererad musik av Aifinity</h1>
              <div className="flex justify-center mb-12">
                <img
                  src="/AIMusicDreams-trasparent.png"
                  alt="AIMusicDreams logotyp"
                  className="mx-auto max-w-[540px] w-full md:max-w-[540px] sm:max-w-[300px]"
                />
              </div>
              <p className="text-xl text-gray-600 mb-10">
                {t.musicproduction.hero.description}
              </p>
              <div className="flex flex-wrap items-center justify-center gap-4">
                <a href="https://open.spotify.com/artist/4mzl9kB6QtB7F2UZktujSY?si=Dl_Ky7l6SGqj8yw_f8k3mQ" target="_blank" rel="noopener noreferrer">
                  <Button 
                    className="text-white px-6 py-5 rounded-xl transition-all hover:scale-105"
                    style={{
                      backgroundColor: '#A754FF',
                      boxShadow: '0 4px 16px rgba(167, 84, 255, 0.3)'
                    }}
                  >
                    <img src="/spotify-alt-1-svgrepo-com.svg" alt="Spotify" className="mr-2 h-5 w-5 filter invert" />
                    {t.musicproduction.hero.spotify}
                  </Button>
                </a>
                <a href="https://soundcloud.com/aimusicdreams" target="_blank" rel="noopener noreferrer">
                  <Button 
                    variant="outline" 
                    className="px-6 py-5 rounded-xl transition-all hover:scale-105"
                    style={{
                      borderColor: '#A754FF',
                      color: '#A754FF',
                      borderWidth: '2px'
                    }}
                  >
                    <img src="/soundcloud-svgrepo-com.svg" alt="SoundCloud" className="mr-2 h-5 w-5" />
                    {t.musicproduction.hero.soundcloud}
                  </Button>
                </a>
                <Link to="/artists">
                  <Button 
                    variant="outline" 
                    className="px-6 py-5 rounded-xl transition-all hover:scale-105"
                    style={{
                      borderColor: '#A754FF',
                      color: '#A754FF',
                      borderWidth: '2px'
                    }}
                  >
                    Utforska Artists
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </section>
        
        {/* About Section */}
        <section className="py-20 relative">
          <div className="container mx-auto px-4">
            <div 
              className="max-w-4xl mx-auto p-12 rounded-3xl"
              style={{
                background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.7) 0%, rgba(167, 84, 255, 0.1) 100%)',
                backdropFilter: 'blur(20px)',
                WebkitBackdropFilter: 'blur(20px)',
                border: '1px solid rgba(255, 255, 255, 0.6)',
                boxShadow: '0 8px 32px rgba(167, 84, 255, 0.15)'
              }}
            >
              <h2 className="text-3xl font-bold mb-8 text-center text-gray-900">
                {t.musicproduction.about.heading}
              </h2>
              <p className="text-xl text-gray-600 mb-6 text-center">
                {t.musicproduction.about.p1}
              </p>
              <p className="text-xl text-gray-600 text-center">
                {t.musicproduction.about.p2}
              </p>
            </div>
          </div>
        </section>
        
        <CorporateFooter />
      </div>
    </div>
  );
};

export default MusicProduction;